import React, { useEffect, useState } from 'react';
import Layout from '../../Layout/Layout';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Col, Row, Form } from 'react-bootstrap';
import Web3 from 'web3';

import config from '../../lib/config'
import { BurnField, deleteStatus, getReportView } from '../../actions/users';

import { toast } from 'react-toastify';



const initialFormValue = {
    "imageName":"" ,
    "imagehash":"",
    "imageOwner":"",
    "imageId":"",
    "imageType":"",
    "imageContractAddress":"",
    "report":"",
    "noofitems":"",
    "burnToken":""
    ,
    "currAddr":"",
    "CreatedAt":""
  }


const ReportView = () => {


    const navigate = useNavigate();
    const { Id } = useParams();


    const [formValue, setFormValue] = useState(initialFormValue);
    const [validateError, setValidateError] = useState({});
    const [showingLoader, setshowingLoader] = useState(false);
    const [showtryagain, setshowtryagain] = useState("false");
    const [owner_Get, set_Owner_Get] = useState('')
    const [noofitemss, setnoofitems] = useState(1);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [deleted, setdeleted] = useState(0)
    const[compeBtn,setcompeBtn]=useState('nodone')


    const onChange = (e) => {
        e.preventDefault();
       
        const { id, value } = e.target;
        let formData = { ...formValue, ...{ [id]: value } }
        setFormValue(formData)
        
        //setValidateError(formData)
      }

      function afterOpenModal() {
        // references are now sync'd and can be accessed.
        // subtitle.style.color = '#f00';
      }
    
      function closeModal() {
        setIsOpen(false);
      }
        const {
          id,
          imageName ,
          imagehash,
          imageOwner,
          imageId,
          imageType,
          imageContractAddress,
          report,
          noofitems,
          burnToken,
          currAddr,
          CreatedAt
        } = formValue
        
    
    
      useEffect(() => {
        getReportData11();
      }, [])
    
      const getReportData11 = async () => {  
        var test = await getReportView(Id);
        
        if(test.userValue.userValue){
        let formdata = {};
        formdata['imageName'] = test.userValue.userValue.imageName;
        formdata['imagehash'] = test.userValue.userValue.imagehash;
        formdata['imageOwner'] = test.userValue.userValue.imageOwner;
        formdata['imageId'] = test.userValue.userValue.imageId;
        formdata['imageType'] = test.userValue.userValue.imageType;
        formdata['imageContractAddress'] = test.userValue.userValue.imageContractAddress;
        formdata['report'] = test.userValue.userValue.report;
        formdata['noofitems'] = test.userValue.userValue.noofitems;
        formdata['burnToken'] = test.userValue.userValue.burnToken;
        formdata['currAddr'] = test.userValue.userValue.currAddr;
        formdata['CreatedAt'] = test.userValue.userValue.CreatedAt;
        setdeleted(test.userValue.deleted);
        setFormValue(formdata);
        //setUser(test.userValue);
        }
      }
      const hideshow=async(dee)=>{
        
        if(dee == 1){
          
            var postdata={
                deleted:0,
                tokenCounts:imageId.toString(),
                tokenOwner:imageOwner
            }
            var resp=await deleteStatus(postdata)
            if(resp&&resp.userValue){
                setTimeout(() => {
                    window.location.reload()
                }, (2000));
          
              }
        }
        else if(dee==0){
          
            var postdata={
                deleted:1,
                tokenCounts:imageId.toString(),
                tokenOwner:imageOwner
            }
            var resp=await deleteStatus(postdata)
            if(resp&&resp.userValue){
                setTimeout(() => {
                    window.location.reload()
                }, (2000));
                 }
        }
        
    
    }

    return (
        <Layout>
            <div className="reportedit">
                <Link to="/reportlist" className="btn sitebtn mb-4">Back</Link>
                <h1 className="pagehead">View Reports</h1>
                <div className="cardbox">
                    <Form>
                        <Row>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Image Name</Form.Label>
                                    <Form.Control type="text" value={imageName || ''} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Image Hash Value</Form.Label>
                                    <Form.Control type="text" value={imagehash || ''} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Image Owner</Form.Label>
                                    <Form.Control type="text" value={imageOwner || ''} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Image Id</Form.Label>
                                    <Form.Control type="text" value={imageId || ''} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Image Type</Form.Label>
                                    <Form.Control type="text" value={imageType || ''} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Image Contract Address</Form.Label>
                                    <Form.Control type="text" value={imageContractAddress || ''} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Report</Form.Label>
                                    <Form.Control type="text" value={report || ''} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>No Of Items</Form.Label>
                                    <Form.Control type="text" value={noofitems || ''} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Burn Token</Form.Label>
                                    <Form.Control type="text" value={ burnToken|| ''} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Reported By</Form.Label>
                                    <Form.Control type="text" value={ currAddr|| ''} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Created At</Form.Label>
                                    <Form.Control type="text" value={CreatedAt || ''} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <button type="button" className="btn sitebtn py-2 px-3" onClick={()=>hideshow(deleted)}>
                            {
                                (deleted==1)?'Visible':'Hidden'
                            }
                        </button>
                    </Form>
                </div>
            </div>
        </Layout>
    )
}

export default ReportView;